import { Schema } from "effect";
export const InterviewAudio = Schema.Struct({
    url: Schema.String,
});
